<template>
  <div class="relative flex justify-center group">
    <button
      class="appearance-none block w-full cursor-pointer"
      type="button"
      @click="onClickContinue"
    >
      <Logo :logo="logo" :show-watermark="true" />
    </button>

    <div
      class="absolute bottom-2 p-2 rounded-lg bg-white bg-opacity-25 inline-flex opacity-0 transition duration-300 group-hover:opacity-100"
    >
      <button class="btn btn-primary" type="button" @click="onClickContinue">
        {{ page.customize }}

        <ArrowRight class="btn-icon-right" />
      </button>
    </div>

    <FavouriteLogoHeart class="absolute top-0 right-0" :logo="logo" />
  </div>
</template>

<script>
import ArrowRight from '@/assets/svg/icons/arrow-right.svg?inline'
import FavouriteLogoHeart from '@/components/favourites/FavouriteLogoHeart'
import { getPages } from '@/mixins/content'
import Logo from '@/components/Logo'

export default {
  components: {
    ArrowRight,
    FavouriteLogoHeart,
    Logo,
  },

  mixins: [getPages(['data/call-to-actions'], true)],

  props: {
    logo: { type: Object, required: true },
  },

  methods: {
    onClickContinue() {
      this.$emit('click', this.logo)
    },
  },
}
</script>
